import i18n from '../translation'

export const _Toolbar = {
  namespaced: true,
  state: {
    // indique le chemin du retour
    back: '',
    // tabs gérés par la toolbar
    // doit être de la forme suivante :
    // [{ to: '/chemin', icon: 'icon', title: 'title' }, ...]
    tabs: [],
    // titre de la toolbar
    title: '',
    // sous-titre de la toolbar
    subTitle: ''
  },
  getters: {
  },
  mutations: {
    INIT (state) {
      state.back = ''
      state.tabs = []
      state.title = ''
      state.subTitle = ''
    },
    /**
     * Défini le chemin de retour de la toolbar
     * @param {String} back  nouveau chemin
     */
    SET_BACK (state, back) {
      state.back = back
    },
    /**
     * Défini les onglets de la toolbar
     * @param {Array} tabs  onglets à afficher
     */
    SET_TABS (state, tabs) {
      state.tabs = tabs
    },
    /**
     * Défini le titre de la toolbar
     * @param {String} title nouveau titre de la toolbar
     */
    SET_TITLE (state, title) {
      let paths = title.split('/')
      let routes = ''
      if (paths[0].length > 0) {
        for (var i = 0; i < paths.length; i++) {
          // traduction de l'élément
          paths[i] = i18n.t(paths[i])
          // mise en majuscule de la première lettre
          paths[i] = paths[i][0].toUpperCase() + paths[i].substring(1)
          // ajout de l'élément parcourue dans le chemin total
          routes += paths[i]
          // ajout d'un '-' si pas dans le dernier élément du chemin
          if (i !== paths.length - 1) {
            routes += ' - '
          }
        }
      }
      state.title = routes
    },
    /**
     * Défini le sous-titre de la toolbar
     * @param {String} subTitle nouveau sous-titre de la toolbar
     */
    SET_SUB_TITLE (state, subTitle) {
      state.subTitle = subTitle
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/toolbar.js